import { downloadCSV } from '@/utils';
import {
  Download as DownloadIcon,
  NoAccounts as NoAccountsIcon,
} from '@mui/icons-material';
import { Box, IconButton, Stack, ToggleButton, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import {
  MaterialReactTable,
  MRT_TablePagination,
  useMaterialReactTable,
} from 'material-react-table';
import { useState } from 'react';
import { useUsers } from './useUsers';

const columns = [
  {
    header: 'User ID',
    accessorKey: 'userId',
  },
  {
    header: 'Email Address',
    accessorKey: 'emailAddress',
  },
  {
    header: 'Forenames',
    accessorKey: 'forenames',
  },
  {
    header: 'Surname',
    accessorKey: 'surname',
  },
  {
    header: 'Display Name',
    accessorKey: 'displayName',
  },
  {
    header: 'Person Code',
    accessorKey: 'personCode',
  },
  {
    header: 'Last Logged In Time',
    accessorKey: 'lastLoggedTime',
    Cell: ({ cell }) => format(cell.getValue(), 'dd/MM/yyyy HH:mm:ss'),
  },
];

export function Users() {
  const {
    query: { data: users, isFetching: usersFetching },
  } = useUsers();
  const [showNoPerson, setShowNoPerson] = useState(false);
  const data = showNoPerson ? users.filter((user) => !user.personCode) : users;

  function handleDownloadClick() {
    const headers = columns.map(({ header, id, accessorKey }) => ({
      label: header,
      key: id ?? accessorKey,
    }));

    downloadCSV(data, 'users.csv', headers);
  }

  function handleToggleShowNoPerson() {
    setShowNoPerson((value) => !value);
  }

  const table = useMaterialReactTable({
    data,
    columns,
    state: {
      density: 'compact',
      isLoading: usersFetching,
    },
    defaultColumn: { size: 0 },
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableTopToolbar: true,
    enableSorting: true,
    enableBottomToolbar: true,
    enablePagination: true,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    // muiTablePaperProps: { elevation: 0, variant: 'elevation' },
    muiTableContainerProps: {
      sx: {
        maxHeight: 'calc(100vh - 160px)', // 48 app header + 56 top bar + 56 bottom bar
      },
    },
    renderTopToolbarCustomActions: () => (
      <Stack spacing={1} direction="row" sx={{ alignItems: 'center', flex: 1 }}>
        <Tooltip
          title={
            showNoPerson
              ? 'Show all users'
              : 'Only Show users with no person assigned'
          }
        >
          <ToggleButton
            value="no-person"
            size="small"
            selected={showNoPerson}
            onChange={handleToggleShowNoPerson}
          >
            <NoAccountsIcon />
          </ToggleButton>
        </Tooltip>
      </Stack>
    ),
    renderBottomToolbar: () => (
      <Stack
        direction="row"
        sx={{ pl: 1, justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Box>
          <Tooltip title="Download data">
            <IconButton size="small" onClick={handleDownloadClick}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <MRT_TablePagination table={table} />
      </Stack>
    ),
  });

  return (
    <Stack>
      <title>IR3 | Users</title>
      <MaterialReactTable table={table} />
    </Stack>
  );
}
